import { setEnvironmentFavicon } from "@homebound/beam";
import { getBackendStage } from "./context";

export const environmentFaviconUrls = {
  default: "/favicon.png",
  dev: "/favicon-dev.png",
  qa: "/favicon-qa.png",
  "local-prod": "/favicon-lp.png",
  prod: "/favicon.png",
};

/** Sets the tab favicon once at app bootstrap based on the backend stage. */
export function setupEnvironmentFavicon() {
  setEnvironmentFavicon(getBackendStage(), environmentFaviconUrls);
}
